module.exports = __webpack_public_path__ + "static/media/wypelnienie.06971c78.svg";